module.exports = __webpack_public_path__ + "static/media/serumAntiox.16df8d4f.png";